import { IS_PRACTICE_INVITE_FLOW_ENABLED } from '@/features/flags';
import { isAppleCompliantBuild } from '@/utils/appConfiguration';
import { OrganisationSize } from '@heidi/schema/ml-scribe';

/** Eligibility for setting `practiceTrialModalPendingAtom` after profile PATCH. */
export function isEligibleForPracticeTrialModal(
  organisationSize: OrganisationSize | null | undefined
): boolean {
  return (
    !!IS_PRACTICE_INVITE_FLOW_ENABLED() &&
    !isAppleCompliantBuild() &&
    organisationSize != null &&
    organisationSize !== OrganisationSize.JUST_ME
  );
}
